/**
 * @prettier
 */
import * as React from 'react';
import { CheckoutElement } from 'src/components/checkout/CheckoutElement';
import { translate } from 'src/i18n/translate';
import { ClockIcon } from 'src/icons/ClockIcon';
import { actions } from 'src/reducers';
import { useAction } from 'src/utils/react/useAction';
import { useSelector } from 'src/utils/react/useSelector';
import { translatePickupTime } from 'src/utils/translate/translatePickupTime';

export function SelectPickupTimeButton(): React.ReactElement {
    const driverArrivesAtStoreTime = useSelector((state) => state.app.driverArrivesAtStoreTime);
    const orderType = useSelector((state) => state.app.orderType);
    const pickupTimeType = useSelector((state) => state.app.pickupTimeType);
    const pickupTime = useSelector((state) => state.app.pickupTime);
    const timeZone = useSelector((state) => state.app.restaurant?.timeZone);
    const preparationTime = useSelector((state) => state.app.restaurant?.preparationTime);

    const openSelectPickupTimeDialog = useAction(actions.openSelectPickupTimeDialog);

    return (
        <CheckoutElement
            title={translate('Program your order')}
            content={translatePickupTime({ driverArrivesAtStoreTime, orderType, pickupTimeType, pickupTime, timeZone, preparationTime })}
            action={openSelectPickupTimeDialog}
            actionTitle={translate('Select delivery time')}
            icon={<ClockIcon color={'#C1C3C8'} />}
        />
    );
}
